import EditProfilePage from './EditProfilePage';

export default EditProfilePage;
